export const CONSENT_KEY = "hsv-cookie-consent";
